import { TAXI_LIST } from "../constants";

export default function(state = [], action) {
  switch (action.type) {
    case TAXI_LIST:
      return action.payload.data;
    default:
      return state;
  }
}
